import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M13.25 9.05c.753 0 1.375.597 1.375 1.35v9.45h1V16.4c0-.708.551-1.28 1.244-1.344L17 15.05h2.5c.753 0 1.375.597 1.375 1.35v3.45h.5a.75.75 0 0 1 .102 1.493l-.102.007H2.625a.75.75 0 0 1-.102-1.493l.102-.007h.5V12.8c0-.708.551-1.28 1.244-1.344l.131-.006H7c.753 0 1.375.597 1.375 1.35v7.05h1V10.4c0-.708.551-1.28 1.244-1.344l.131-.006zm6.125 7.499h-2.25v3.301h2.25v-3.301zm-6.25-6h-2.25v9.301h2.25v-9.301zm-6.25 2.401h-2.25v6.9h2.25v-6.9zM4.309 1.988l.085.071 4.86 4.666c.254.243.616.356.971.307l.133-.026 4.737-1.218a2.684 2.684 0 0 1 2.45.506l.141.125 2.939 2.823v-1.84a.75.75 0 0 1 .648-.743l.102-.007a.75.75 0 0 1 .743.649l.007.101v3.622a.754.754 0 0 1-.003.043l.003-.065a.755.755 0 0 1-.147.446.755.755 0 0 1-.501.298l-.017.002a.754.754 0 0 1-.05.004h-3.785a.75.75 0 0 1-.102-1.493l.102-.007h1.886l-2.864-2.751a1.177 1.177 0 0 0-1.016-.298l-.142.032-4.758 1.224a2.684 2.684 0 0 1-2.38-.53l-.135-.122-4.86-4.666a.75.75 0 0 1 .953-1.153z' />
  </svg>
);
